import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

export function SteamRedirect(): JSX.Element {
  const history = useHistory();

  const parseUrl = (): string => {
    const stringParams = window.location.hash.split('#')[1];
    const searchParams = new URLSearchParams(stringParams);
    return searchParams.get('access_token');
  };

  useEffect(() => {
    if (!window.opener) {
      history.push('/account');
    }

    const steamData = parseUrl();

    if (steamData) {
      window.opener.postMessage({ steamData }, '*');
    }

    window.close();
  }, []);

  return (
    <div className='container'>
      <div className='auth-container'>
        <div className='auth-card'>
          <div className='row'>
            <div className='col text-center'>
              <p>Redirect...</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
